const slugify = require('slugify')

export default (title: string) => slugify(title).substring(0, 50).toLowerCase()
